module.exports = __webpack_public_path__ + "static/img/img_1.d9889c11.jpg";